export default {"src":"/_next/static/media/ProductDetail.2f9b277c.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};